module.exports = __webpack_public_path__ + "static/media/noc-download.431854e1.png";